@let label = labelSg();

<div class="atn-ds-input-field">
  @if (label) {
    <span class="atn-ds-input-field__label"> {{ label }} </span>
  }
  <input
    #textInput
    class="atn-ds-input-field__control"
    [class.atn-ds-input-field__control--no-border]="!hasBorderSg()"
    type="text"
    [value]="valueSg() ?? null"
    (change)="onChangeHandler($event)"
    (input)="input.emit(textInput.value)"
    [disabled]="disabledSg()"
    [placeholder]="placeholderSg()"
  />
</div>
